export default __webpack_public_path__ + "static/media/logo-cartao-alianca.046dafdf.svg";